import React, { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const PoliticaPrivacidade = () => {
  const [settings, setSettings] = useState({
    site_name: 'Santa Carne',
    email: 'geralsantacarne@gmail.com',
    address: 'Rua das laranjeiras, 14\nMafra - PT 2640-577'
  });

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await fetch(`${API_URL}/api/public/settings`);
        if (response.ok) {
          const data = await response.json();
          setSettings(prev => ({
            ...prev,
            ...data
          }));
          document.title = `Política de Privacidade - ${data.site_name || 'Santa Carne'}`;
        }
      } catch (err) {
        console.error('Erro ao carregar configurações:', err);
      }
    };
    fetchSettings();
  }, []);

  return (
    <div className="min-h-screen bg-[#1a1a1a] pt-20">
      {/* Hero Section */}
      <section className="relative py-20 flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 z-0 bg-gradient-to-b from-[#242424] to-[#1a1a1a]" />
        
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 z-10 text-center">
          <p className="text-[#B8860B] text-sm tracking-[0.3em] uppercase mb-4">Legal</p>
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-semibold text-[#E8DDCB] mb-6" style={{fontFamily: "'Playfair Display', serif"}}>
            Política de Privacidade
          </h1>
          <div className="w-16 h-[2px] bg-[#B8860B] mx-auto mb-6" />
          <p className="text-[#E8DDCB]/70 text-sm">
            Última atualização: {new Date().toLocaleDateString('pt-PT', { month: 'long', year: 'numeric' })}
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 bg-[#1a1a1a]">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">
          <div className="prose prose-invert max-w-none">
            
            <div className="mb-12">
              <h2 className="text-2xl font-semibold text-[#B8860B] mb-4" style={{fontFamily: "'Playfair Display', serif"}}>
                1. Introdução
              </h2>
              <p className="text-[#E8DDCB]/80 leading-relaxed mb-4">
                A {settings.site_name} está empenhada em proteger a privacidade e os dados pessoais dos seus clientes e utilizadores do website. Esta Política de Privacidade explica como recolhemos, utilizamos e protegemos as suas informações pessoais.
              </p>
              <p className="text-[#E8DDCB]/80 leading-relaxed">
                Ao utilizar o nosso website ou serviços, está a aceitar as práticas descritas nesta política.
              </p>
            </div>

            <div className="mb-12">
              <h2 className="text-2xl font-semibold text-[#B8860B] mb-4" style={{fontFamily: "'Playfair Display', serif"}}>
                2. Dados Recolhidos
              </h2>
              <p className="text-[#E8DDCB]/80 leading-relaxed mb-4">
                Podemos recolher os seguintes tipos de informação:
              </p>
              <ul className="list-disc list-inside text-[#E8DDCB]/80 space-y-2 ml-4">
                <li><strong className="text-[#E8DDCB]">Dados de identificação:</strong> nome, email, telefone, morada</li>
                <li><strong className="text-[#E8DDCB]">Dados de contacto:</strong> informações fornecidas através do formulário de contacto</li>
                <li><strong className="text-[#E8DDCB]">Dados de navegação:</strong> endereço IP, tipo de browser, páginas visitadas</li>
                <li><strong className="text-[#E8DDCB]">Dados de encomendas:</strong> histórico de compras e preferências</li>
              </ul>
            </div>

            <div className="mb-12">
              <h2 className="text-2xl font-semibold text-[#B8860B] mb-4" style={{fontFamily: "'Playfair Display', serif"}}>
                3. Finalidade do Tratamento
              </h2>
              <p className="text-[#E8DDCB]/80 leading-relaxed mb-4">
                Os seus dados pessoais são tratados para as seguintes finalidades:
              </p>
              <ul className="list-disc list-inside text-[#E8DDCB]/80 space-y-2 ml-4">
                <li>Processar e gerir encomendas</li>
                <li>Responder a pedidos de informação e contactos</li>
                <li>Enviar informações sobre produtos e promoções (com consentimento)</li>
                <li>Melhorar os nossos serviços e experiência do utilizador</li>
                <li>Cumprir obrigações legais e regulamentares</li>
              </ul>
            </div>

            <div className="mb-12">
              <h2 className="text-2xl font-semibold text-[#B8860B] mb-4" style={{fontFamily: "'Playfair Display', serif"}}>
                4. Base Legal
              </h2>
              <p className="text-[#E8DDCB]/80 leading-relaxed">
                O tratamento dos seus dados pessoais baseia-se no consentimento que nos fornece, na execução de contratos, no cumprimento de obrigações legais e nos nossos interesses legítimos em melhorar os serviços prestados.
              </p>
            </div>

            <div className="mb-12">
              <h2 className="text-2xl font-semibold text-[#B8860B] mb-4" style={{fontFamily: "'Playfair Display', serif"}}>
                5. Partilha de Dados
              </h2>
              <p className="text-[#E8DDCB]/80 leading-relaxed mb-4">
                Não vendemos nem partilhamos os seus dados pessoais com terceiros para fins de marketing. Podemos partilhar informações apenas com:
              </p>
              <ul className="list-disc list-inside text-[#E8DDCB]/80 space-y-2 ml-4">
                <li>Prestadores de serviços que nos auxiliam nas operações (ex: entregas)</li>
                <li>Autoridades competentes quando exigido por lei</li>
              </ul>
            </div>

            <div className="mb-12">
              <h2 className="text-2xl font-semibold text-[#B8860B] mb-4" style={{fontFamily: "'Playfair Display', serif"}}>
                6. Segurança dos Dados
              </h2>
              <p className="text-[#E8DDCB]/80 leading-relaxed">
                Implementamos medidas técnicas e organizativas adequadas para proteger os seus dados pessoais contra acesso não autorizado, perda, destruição ou alteração. Estas medidas incluem encriptação, controlos de acesso e procedimentos de segurança.
              </p>
            </div>

            <div className="mb-12">
              <h2 className="text-2xl font-semibold text-[#B8860B] mb-4" style={{fontFamily: "'Playfair Display', serif"}}>
                7. Retenção de Dados
              </h2>
              <p className="text-[#E8DDCB]/80 leading-relaxed">
                Os seus dados pessoais são conservados apenas durante o período necessário para as finalidades para as quais foram recolhidos, ou conforme exigido por lei. Após este período, os dados são eliminados de forma segura.
              </p>
            </div>

            <div className="mb-12">
              <h2 className="text-2xl font-semibold text-[#B8860B] mb-4" style={{fontFamily: "'Playfair Display', serif"}}>
                8. Os Seus Direitos
              </h2>
              <p className="text-[#E8DDCB]/80 leading-relaxed mb-4">
                Ao abrigo do Regulamento Geral de Proteção de Dados (RGPD), tem os seguintes direitos:
              </p>
              <ul className="list-disc list-inside text-[#E8DDCB]/80 space-y-2 ml-4">
                <li><strong className="text-[#E8DDCB]">Direito de acesso:</strong> obter confirmação sobre o tratamento dos seus dados</li>
                <li><strong className="text-[#E8DDCB]">Direito de retificação:</strong> corrigir dados inexatos ou incompletos</li>
                <li><strong className="text-[#E8DDCB]">Direito ao apagamento:</strong> solicitar a eliminação dos seus dados</li>
                <li><strong className="text-[#E8DDCB]">Direito à portabilidade:</strong> receber os seus dados em formato estruturado</li>
                <li><strong className="text-[#E8DDCB]">Direito de oposição:</strong> opor-se ao tratamento dos seus dados</li>
              </ul>
            </div>

            <div className="mb-12">
              <h2 className="text-2xl font-semibold text-[#B8860B] mb-4" style={{fontFamily: "'Playfair Display', serif"}}>
                9. Cookies
              </h2>
              <p className="text-[#E8DDCB]/80 leading-relaxed">
                O nosso website utiliza cookies para melhorar a sua experiência de navegação. Os cookies são pequenos ficheiros de texto armazenados no seu dispositivo. Pode configurar o seu browser para recusar cookies, mas isto pode afetar algumas funcionalidades do website.
              </p>
            </div>

            <div className="mb-12">
              <h2 className="text-2xl font-semibold text-[#B8860B] mb-4" style={{fontFamily: "'Playfair Display', serif"}}>
                10. Contacto
              </h2>
              <p className="text-[#E8DDCB]/80 leading-relaxed mb-4">
                Para exercer os seus direitos ou esclarecer qualquer dúvida sobre esta política, contacte-nos:
              </p>
              <div className="bg-[#242424] p-6 rounded-lg border border-[#B8860B]/20">
                <p className="text-[#E8DDCB] mb-2"><strong>Email:</strong> {settings.email}</p>
                <p className="text-[#E8DDCB] whitespace-pre-line"><strong>Morada:</strong> {settings.address}</p>
              </div>
            </div>

            <div className="mb-12">
              <h2 className="text-2xl font-semibold text-[#B8860B] mb-4" style={{fontFamily: "'Playfair Display', serif"}}>
                11. Alterações à Política
              </h2>
              <p className="text-[#E8DDCB]/80 leading-relaxed">
                Reservamo-nos o direito de alterar esta Política de Privacidade a qualquer momento. Quaisquer alterações serão publicadas nesta página com a data de atualização. Recomendamos que consulte esta página periodicamente.
              </p>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default PoliticaPrivacidade;
